module.exports = __webpack_public_path__ + "static/img/photo.bc38541.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/photo.jpg
// module id = yVLB
// module chunks = 1